<template>
   <div class="serveBox">
        <div class="sbControl">
            <ul @mouseover="tabClick(1)" :class="controlDiv === 1 ? 'ulBottom' : ''">
                <li>
                    <img v-if="controlDiv === 1" src="../../../static/index/icon1.png" alt="" />
                    <img v-else src="../../../static/index/icon1s.png" alt="" />
                    <span :class="controlDiv === 1 ? 'svgColor' : ''">权威平台</span>
                </li>
            </ul>
            <ul @mouseover="tabClick(2)" :class="controlDiv === 2 ? 'ulBottom' : ''">
                <li>
                    <img v-if="controlDiv === 2" src="../../../static/index/icon2s.png" alt="" />
                    <img v-else src="../../../static/index/icon2.png" alt="" />
                    <span :class="controlDiv === 2 ? 'svgColor' : ''">资金安全</span>
                </li>
            </ul>
            <ul @mouseover="tabClick(3)" :class="controlDiv === 3 ? 'ulBottom' : ''">
                <li>
                    <img v-if="controlDiv === 3" src="../../../static/index/icon3s.png" alt="" />
                    <img v-else src="../../../static/index/icon3.png" alt="" />
                    <span :class="controlDiv === 3 ? 'svgColor' : ''">服务专业</span>
                </li>
            </ul>
            <ul @mouseover="tabClick(4)" :class="controlDiv === 4 ? 'ulBottom' : ''">
                <li>
                    <img v-if="controlDiv === 4" src="../../../static/index/icon4s.png" alt="" />
                    <img v-else src="../../../static/index/icon4.png" alt="" />
                    <span :class="controlDiv === 4 ? 'svgColor' : ''">丰富活动</span>
                </li>
            </ul>
            <ul @mouseover="tabClick(5)" :class="controlDiv === 5 ? 'ulBottom' : ''">
                <li>
                    <img v-if="controlDiv === 5" src="../../../static/index/icon5s.png" alt="" />
                    <img v-else src="../../../static/index/icon5.png" alt="" />
                    <span :class="controlDiv === 5 ? 'svgColor' : ''">软件强大</span>
                </li>
            </ul>
        </div>
        <div class="sbShow">
            <div class="showChild" v-if="controlDiv === 1">
                <div class="showcont" @click="scrollToTarget">
                    <div class="tits">权威平台</div>
                    <div class="lines"></div>
                    <div class="cont">
                        <span>红狮集团，获香港黄金交易所监管</span>
                        <span>属香港黄金交易所AA类行员</span>
                        <span>多次获得“最佳贵金属交易平台金企”称号</span>
                    </div>
                    <img class="load" src="../../../static/index/download1.png" alt="" />
                </div>
                <img src="../../../static/index/advantage1.png" alt="" />
            </div>
            <div class="showChild" v-if="controlDiv === 2">
                <div class="showcont" @click="scrollToTarget">
                    <div class="tits">资金安全</div>
                    <div class="lines"></div>
                    <div class="cont">
                        <span>出入金顺畅，资金安全有保障，可在APP</span>
                        <span>或用户中心即时查看资金变动的具体情况</span>

                    </div>
                    <img class="load" src="../../../static/index/download1.png" alt="" />
                </div>
                <img src="../../../static/index/advantage2.png" alt="" />
            </div>
            <div class="showChild" v-if="controlDiv === 3">
                <div class="showcont" @click="scrollToTarget">
                    <div class="tits">服务专业</div>
                    <div class="lines"></div>
                    <div class="cont">
                        <span>7*24小时专业客服，随时解决您任何投资</span>
                        <span>疑问</span>

                    </div>
                    <img class="load" src="../../../static/index/download1.png" alt="" />
                </div>
                <img src="../../../static/index/advantage3.png" alt="" />
            </div>
            <div class="showChild" v-if="controlDiv === 4">
                <div class="showcont" @click="scrollToTarget">
                    <div class="tits">丰富活动</div>
                    <div class="lines"></div>
                    <div class="cont">
                        <span>享优越点差，省即是赚，同时还有丰富的新</span>
                        <span>用户注册活动，享赠金好礼</span>


                    </div>
                    <img class="load" src="../../../static/index/download1.png" alt="" />
                </div>
                <img src="../../../static/index/advantage4.png" alt="" />
            </div>
            <div class="showChild" v-if="controlDiv === 5">
                <div class="showcont" @click="scrollToTarget">
                    <div class="tits">软件强大</div>
                    <div class="lines"></div>
                    <div class="cont">
                        <span>全新智能化软件，独家开发交易利器，超强</span>
                        <span>下单执行能力，是您交易的强大后盾</span>

                    </div>
                    <img class="load" src="../../../static/index/download1.png" alt="" />
                </div>
                <img src="../../../static/index/advantage5.png" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
data() {
    return {
        // 控制craigBox
        controlImg: {
            baozhiImgs: true,
            sxjzImgs: false,
            sctmImgs: false,
            jylhImgs: false,
        },
        // 控制serveBox
        controlDiv: 1,

        craigCao: 0,
        baozhiImgs: [
            require("../../../static/index/baozhiIcon.png"),
            require("../../../static/index/jiaohu/bzx.png"),
        ],
        sxjzImgs: [
            require("../../../static/index/jiaohu/sxjz.png"),
            require("../../../static/index/sxjzIcon.png"),
        ],
        sctmImgs: [
            require("../../../static/index/jiaohu/sctm.png"),
            require("../../../static/index/sctmIcon.png"),
        ],
        jylhImgs: [
            require("../../../static/index/jiaohu/jylh.png"),
            require("../../../static/index/jylhIcon.png"),
        ],
        LondonImg: [
            require("../../../static/index/jiaohu/up.png"),
            require("../../../static/index/jiaohu/down.png"),
        ],
      selectedImg: require("../../../static/index/yuandian.png"),

    }
},
methods: {
    // 点击跳转到指定位置
    scrollToTarget() {
        const targetElements = this.$refs.targetElement;
        const targetPosition = targetElements.offsetTop;
        window.scrollTo({
            top: targetPosition,
            behavior: "smooth",
        });
    },
    handleScroll() {
        //改变元素#searchBar的top值


    },
    // 切换serveBox的方法
    updateDiv() {
        if (this.controlDiv < 5) {
            this.controlDiv = this.controlDiv + 1;
        } else {
            this.controlDiv = 1;
        }
    },
    // 鼠标移入事件
    mouseOver(attr) {
        switch (attr) {
            case 1:
                this.controlImg.baozhiImgs = true;
                break;
            case 2:
                this.controlImg.sxjzImgs = true;
                this.controlImg.baozhiImgs = false;
                break;
            case 3:
                this.controlImg.sctmImgs = true;
                this.controlImg.baozhiImgs = false;
                break;
            case 4:
                this.controlImg.jylhImgs = true;
                this.controlImg.baozhiImgs = false;
                break;
        }
    },
    // 鼠标移出事件
    mouseLeave(attr) {
        switch (attr) {
            case 1:
                this.controlImg.baozhiImgs = false;
                break;
            case 2:
                this.controlImg.sxjzImgs = false;
                break;
            case 3:
                this.controlImg.sctmImgs = false;
                break;
            case 4:
                this.controlImg.jylhImgs = false;
                break;
        }
    },
    // 鼠标移出整个box时，设置默认展开栏
    totalLeave() {
        this.controlImg.baozhiImgs = true;
    },
    // tabbar点击事件
    tabClick(attr) {
        switch (attr) {
            case 1:
                this.controlDiv = attr;
                break;
            case 2:
                this.controlDiv = attr;
                break;
            case 3:
                this.controlDiv = attr;
                break;
            case 4:
                this.controlDiv = attr;
                break;
            case 5:
                this.controlDiv = attr;
                break;
        }
    },
},
created() {
  
    // 自动切换serveBox
    setInterval(this.updateDiv, 4000);
}
}
</script>

<style lang="less" scoped>
.serveBox {
    width: 100%;

    .sbControl {
        width: 1130px;
        height: 110px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        // border-bottom: 1px solid #e2e2e2;

        ul {
            width: 15%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            cursor: pointer;

            li {
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 15px;
                color: #6d6d6d;
                margin-bottom: 10px;

                .svgColor {
                    color: #d52226;
                }

                span {
                    font-size: 18px;
                    color: #121212;
                    margin-top: 12px;
                }

                img {
                    width: 50px;
                    height: 50px;
                }
            }
        }
    }

    .sbShow {
        width: 100%;
        margin-top: 48px;

        .showChild {
            width: 100%;
            height: 442px;
            display: flex;

            align-items: center;

            img {
                width: 812px;
                height: 442px;

            }

            .showcont {
                width: 546px;
                // min-width: 950px;
                margin-left: 15%;
                height: 378px;
                padding: 48px;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                background: linear-gradient(105.21deg, #fa2314 0%, #db2c23 100%);
                box-sizing: border-box;
                color: #fff;
                cursor: pointer;

                .tits {
                    font-size: 32px;
                    line-height: 42px;
                    font-weight: 700;
                }

                .lines {
                    width: 40px;
                    height: 4px;
                    background: #fff;
                    margin: 16px 0;
                }

                .cont {
                    width: 342px;
                    font-size: 18px;
                    line-height: 24px;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                }

                .cont span:nth-child(2) {
                    margin: 10px 0;
                }

                .load {
                    width: 198px;
                    height: 56px;
                    margin-top: 64px;
                    cursor: pointer;
                }
            }
        }
    }
}

@media screen and (min-width: 1264px) and (max-width: 1724px) {
    .serveBox {
            width: 100%;
    
            .sbControl {
                width: 1000px;
                height: 110px;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                // border-bottom: 1px solid #e2e2e2;
    
                ul {
                    width: 15%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    cursor: pointer;
    
                    li {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        font-size: 15px;
                        color: #6d6d6d;
                        margin-bottom: 10px;
    
                        .svgColor {
                            color: #d52226;
                        }
    
                        span {
                            font-size: 18px;
                            color: #121212;
                            margin-top: 12px;
                        }
    
                        img {
                            width: 50px;
                            height: 50px;
                        }
                    }
                }
            }
    
            .sbShow {
                width: 100%;
                margin-top: 48px;
    
                .showChild {
                    width: 100%;
                    height: 442px;
                    display: flex;
    
                    align-items: center;
    
                    img {
                        width: 612px;
                        height: 442px;
    
                    }
    
                    .showcont {
                        width: 446px;
                        // min-width: 950px;
                        margin-left: 10%;
                        height: 378px;
                        padding: 48px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        background: linear-gradient(105.21deg, #fa2314 0%, #db2c23 100%);
                        box-sizing: border-box;
                        color: #fff;
                        cursor: pointer;
    
                        .tits {
                            font-size: 32px;
                            line-height: 42px;
                            font-weight: 700;
                        }
    
                        .lines {
                            width: 40px;
                            height: 4px;
                            background: #fff;
                            margin: 16px 0;
                        }
    
                        .cont {
                            width: 342px;
                            font-size: 18px;
                            line-height: 24px;
                            display: flex;
                            flex-direction: column;
                            align-items: flex-start;
                        }
    
                        .cont span:nth-child(2) {
                            margin: 10px 0;
                        }
    
                        .load {
                            width: 198px;
                            height: 56px;
                            margin-top: 64px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
}
</style>